/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery,
  type DataTag,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type { AccountStates, Error } from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Retrieve account states
 */
export const getAccountStates = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<AccountStates>(
    { url: `/api/v1/accounts/${accountId}/state`, method: "GET", signal },
    options,
  )
}

export const getGetAccountStatesQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v1", "accounts", accountId, "state"] as const
}

export const useGetAccountStatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountStates>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountStates>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetAccountStatesQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountStates>>
  > = ({ signal }) => getAccountStates(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountStates>>,
    TError,
    TData
  >
}

export type GetAccountStatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountStates>>
>
export type GetAccountStatesQueryError = ErrorType<Error>

/**
 * @summary Retrieve account states
 */

export function useGetAccountStates<
  TData = Awaited<ReturnType<typeof getAccountStates>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountStates>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetAccountStatesQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}
